import type { Module } from '@pc/core';
import { probeSchemaIsExposed } from '@pc/db';
import { lazyWithReload } from '@pc/ui';
import './events';

// Use `lazyWithReload` so a stale-shell operator that navigates into a
// module page after a deploy auto-recovers via a debounced page reload
// instead of crashing with "Failed to fetch dynamically imported
// module: .../OrdersListPage-<oldhash>.js". See
// packages/ui/src/lazyWithReload.ts.
const OrdersListPage = lazyWithReload(() => import('./pages/OrdersListPage'));
const OrderNewPage = lazyWithReload(() => import('./pages/OrderNewPage'));
const OrderDetailPage = lazyWithReload(() => import('./pages/OrderDetailPage'));
const OrdersDashboardWidget = lazyWithReload(
  () => import('./pages/OrdersDashboardWidget'),
);

export const ordersModule: Module = {
  id: 'orders',
  name: 'Orders',
  description: 'Proposal -> approval -> invoice -> payment. End to end.',
  basePath: '/orders',
  routes: [
    { path: '/', element: <OrdersListPage /> },
    { path: '/new', element: <OrderNewPage /> },
    { path: '/:id', element: <OrderDetailPage /> },
  ],
  navItems: [{ label: 'Orders', to: '/orders', order: 20 }],
  dashboardWidgets: [
    { id: 'orders-pipeline', span: 2, order: 20, render: OrdersDashboardWidget },
  ],
  events: {
    publishes: ['order.created', 'order.proposal_sent', 'order.approved', 'order.invoiced', 'order.paid'],
  },
  healthProbe: () => probeSchemaIsExposed('orders', 'v_order_summary'),
};
